import { menuEn as libMenuEn } from '@rfc/rfc-components-library/locales'

export const menuEn = {
    ...libMenuEn,
    customers: 'Customers',
    orders: 'Orders',
    templates: 'Print Templates',
    products: 'Products',
    productionLines: 'Production lines',
    adminOrders: 'Orders',
    adminTemplates: 'Print Templates',
    adminCustomers: 'Customers',
    adminProducts: 'Products',
    adminProductionLines: 'Production lines'
}
